// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1tThf","productName":"Table_productName__w7oCY"};